/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

/**
 * Redirects users on HBO press portal to HBOMax press portal /login.
 * Uses config.Partners to determine source (HBO) and target (HBO_MAX_PORTAL) hostnames,
 * allowing this function to work across all environments without hardcoding.
 * @param {Object} config - App config (environment-specific)
 */
const checkAndRedirectLegacyHboPortal = (config) => {
    if (typeof window === 'undefined') {
        return;
    }

    const params = new URLSearchParams(window.location.search);
    // Bypass redirect from HBO portal for internal access/testing
    if (params.get('skipRedirect') === '1') {
        return;
    }

    const {HBO, HBO_MAX_PORTAL} = (config && config.Partners) || {};
    if (!HBO?.hostname || !HBO_MAX_PORTAL?.baseUrl) {
        return;
    }

    const shouldRedirect = window.location.hostname === HBO.hostname;
    if (!shouldRedirect) {
        return;
    }

    const target = new URL(HBO_MAX_PORTAL.baseUrl);
    target.pathname = '/login';
    // Override next query parameter since HBO resources may not exist on HBOMax
    target.searchParams.set('next', '/');
    window.location.replace(target.href);
};

export {checkAndRedirectLegacyHboPortal};
